export default "__VITE_ASSET__C3teLuYt__"